import { render, staticRenderFns } from "./PackageIncentivesTab.vue?vue&type=template&id=d7091b70&scoped=true&"
import script from "./PackageIncentivesTab.vue?vue&type=script&lang=js&"
export * from "./PackageIncentivesTab.vue?vue&type=script&lang=js&"
import style0 from "./PackageIncentivesTab.vue?vue&type=style&index=0&id=d7091b70&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7091b70",
  null
  
)

export default component.exports